@if (topExtensions.length > 0) {
  <div class="analytics-container" [ngClass]="{ 'show': showAnalytics }">
    <div class="analytics-wrapper">
      <ngx-charts-pie-chart
        [view]="chartOpts.view"
        [scheme]="chartOpts.scheme"
        [results]="topExtensions"
        [legend]="chartOpts.showLegend"
        [legendPosition]="chartOpts.legendPosition"
        [labels]="chartOpts.showLabels"
        (select)="onChartClick($event)"
      ></ngx-charts-pie-chart>
    </div>
    <div class="analytics-wrapper flex">
      <h2>File Size</h2>
      <div class="panel-content">
        <h3 class="grid-item header left">Min</h3>
        <h3 class="grid-item header">Max</h3>
        <div class="grid-item value left">{{ analytics.size.min | formatBytes }}</div>
        <div class="grid-item value">{{ analytics.size.max | formatBytes }}</div>
      </div>
    </div>
    <div class="analytics-wrapper flex last">
      <h2>Modify Date</h2>
      <div class="panel-content">
        <h3 class="grid-item header left">Oldest</h3>
        <h3 class="grid-item header">Newest</h3>
        <div class="grid-item value left">{{ analytics.modifyDate.min | formatTRACSDate }}</div>
        <div class="grid-item value">{{ analytics.modifyDate.max | formatTRACSDate }}</div>
      </div>
    </div>
  </div>
}

<div class="analytics-toggle">
  <i class="fas fa-chevron-up" [ngClass]="{ 'flip': !showAnalytics }" (click)="toggleDisplay()"></i>
</div>